<template>
    <div class="form-input-container">
        <div class="form-title text-primary"><label>{{translate(label)}} <span class="required" v-if="required">*</span></label></div>
        <div style="display: flex; align-items: center;">
            <datetime type="date" v-model="localValue" auto value-zone="UTC+7"></datetime>
        </div>
    </div>
</template>
<script>
    import { Datetime } from 'vue-datetime';
    export default {
        components: {Datetime},
        props: {
            value: {}, label: {},
            required: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: "text"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localValue: null
            }
        },
        created() {
            this.setFieldValue();
        },
        methods: {
            setFieldValue() {
                this.localValue = this.value;
            }
        },
        watch: {
            localValue(val) {
                this.$emit('input', String(val).slice(0, 10));
            },
            value(val) {
                this.setFieldValue();
            },
        },
        computed: {
            model: {
                get() {
                    return this.localValue
                },
                set(value) {
                    if (value.constructor.name.toLowerCase() !== 'inputevent') {
                        this.$nextTick(() => {
                            this.localValue = value
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .form-input-container {
        margin-bottom: 12px;
    }

    .form-title {
        margin-bottom: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Form/Datetime.vue